<template>
  <div class="h-screen flex justify-center items-center">
    <div class="text-center">
      <div class="p-5"><img src="./images/logo-horizontal-color.png"></div>
      <div class="p-5"><a :href="externalLoginLink" class="login-button border border-white border-solid px-6 py-4 text-white px-1">Log in / Sign up</a></div>
      <div class="mt-5 text-white">
        <div>
          Here from <a href="http://www.thedigitalpress.co/tutorial-tuesday-on-minimalism-sharing-digital-scrapbooks/" target="_blank" class="home-link">The Digital Press Blog</a>? Want to see an <a href="/albums/50/milo" class="home-link">example album</a>?
        </div>
        <div class="mt-2 flex justify-center">
          <a href="/albums/50/milo">
            <img class="max-w-lg" src="http://www.thedigitalpress.co/wp-content/uploads/2019/08/sharemyscrapbook2.gif">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExternalLoginLink } from '../utils/routing'
export default {
  mounted() {
    if (this.$store.state.user) {
      this.$router.replace('/dashboard')
    }
  },
  data() {
    return {
      externalLoginLink: getExternalLoginLink(),
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-button
  &:hover
    border-color theme('colors.lighter-teal')
    color theme('colors.lighter-teal')

.home-link
  color theme('colors.mustard')
  font-weight 500
</style>
